export const getValueOrDefault = (
  value,
  defaultValue,
  formatMessage,
  keepEmpty = false
) => {
  const parts = `${value || ''}`.split('-') || []
  if (parts[0] === defaultValue && parts.length > 1) {
    return `${formatMessage(defaultValue)}`
  }
  if (keepEmpty) {
    return defaultValue === value ? formatMessage(defaultValue) : value
  }
  return defaultValue === value || !value || (value && !`${value || ''}`.trim())
    ? formatMessage(defaultValue)
    : value
}

export const getValueOrDefaultText = (
  value,
  defaultValue,
  keepEmpty = false
) => {
  const parts = `${value || ''}`.split('-') || []
  if (parts[0] === defaultValue && parts.length > 1) {
    return defaultValue
  }
  if (keepEmpty) {
    return defaultValue === value ? defaultValue : value
  }
  return defaultValue === value || !value || (value && !`${value || ''}`.trim())
    ? defaultValue
    : value
}
